/* eslint-disable import/no-default-export */
import React from 'react';

const ForwardIcon = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color || 'currentColor'}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.292 4.2915C11.903 4.6795 11.903 5.3165 12.292 5.7055L17.586 10.9995H4C3.45 10.9995 3 11.4495 3 11.9995C3 12.5505 3.45 13.0005 4 13.0005H17.586L12.289 18.2965C11.9 18.6855 11.9 19.3215 12.289 19.7105C12.678 20.1005 13.315 20.1005 13.703 19.7105L20.702 12.7125C20.704 12.7115 20.706 12.7095 20.709 12.7075C20.903 12.5145 21 12.2565 21 11.9995C21 11.7425 20.903 11.4855 20.709 11.2915C20.706 11.2905 20.703 11.2885 20.701 11.2865L13.706 4.2915C13.512 4.0975 13.255 4.0005 12.999 4.0005C12.743 4.0005 12.486 4.0975 12.292 4.2915Z"
    />
  </svg>
);

export default ForwardIcon;
